<template>
  <div>
    <v-menu></v-menu>
    <v-streak></v-streak>
    <v-infoUndraw></v-infoUndraw>
    <v-infoMain></v-infoMain>
    <v-infoDetails></v-infoDetails>
    <div class="col-lg-12 aqua-gradient pl-0 pr-0">
      <a href="tel:7876357455" class="btn btn-block text-white pt-5 pb-5">
        <h5><i class="fa fa-phone ml-2"></i> LLama Ahora</h5>
      </a>
    </div>
    <v-enlases></v-enlases>
    <hr />
    <v-galeria></v-galeria>
    <hr />
    <div id="contacto" class="text-center mt-5 mb-n0">
      <h5 class="mb-5 mt-5">MAPA</h5>
      <div class="embed-responsive embed-responsive-21by9">
        <iframe
          class="embed-responsive-item"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d60733.17577758842!2d-66.953719!3d17.940385!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x1fabda071d1baed6!2sParadise%20Apts!5e0!3m2!1sen!2sus!4v1590090146404!5m2!1sen!2sus"
          width="600"
          height="450"
          frameborder="0"
          style="border:0;"
          allowfullscreen=""
          aria-hidden="false"
          tabindex="0"
        ></iframe>
      </div>
    </div>

    <div
      class="fixed-action-btn smooth-scroll"
      style="bottom: 0px; right: 0px;"
    >
      <a @click="home" class="btn-floating btn-large aqua-gradient">
        <i class="fas fa-arrow-up"></i>
      </a>
    </div>

    <v-footer></v-footer>
  </div>
</template>

<script>
export default {
  methods: {
    home() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>
